"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const SCHEMA = 'iglu:com.angi.entities/page_attributes/jsonschema/3-0-0';
/**
 * Generates the page_attributes context
 *
 * @param pageName - descriptive page name
 */
const pageAttributesContext = (pageName) => {
    return {
        schema: SCHEMA,
        data: { name: pageName },
    };
};
exports.default = pageAttributesContext;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFnZUF0dHJpYnV0ZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvZGF0YVN0cnVjdHVyZXMvZW50aXRpZXMvcGFnZUF0dHJpYnV0ZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFFQSxNQUFNLE1BQU0sR0FBRyx5REFBeUQsQ0FBQztBQUV6RTs7OztHQUlHO0FBQ0gsTUFBTSxxQkFBcUIsR0FBRyxDQUFDLFFBQWdCLEVBQXNCLEVBQUU7SUFDbkUsT0FBTztRQUNILE1BQU0sRUFBRSxNQUFNO1FBQ2QsSUFBSSxFQUFFLEVBQUUsSUFBSSxFQUFFLFFBQVEsRUFBRTtLQUMzQixDQUFDO0FBQ04sQ0FBQyxDQUFDO0FBRUYsa0JBQWUscUJBQXFCLENBQUMifQ==


// WEBPACK FOOTER //
// ../../../../src/dataStructures/entities/pageAttributes.ts